import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const USER_INFO_URL = `${PAY}/member/user-info`
const USER_INFO_PC_URL = `${PAY}/member/user-info?fromPC=Y`

const POPUP_KEY = 'USER_INFO_KEY'

/**
 * 유저 회원정보 페이지로 이동
 */
const navigateToUserInfo = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi<unknown>>(
    'navigateTo/userInfo',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}
        const navigateByLocationChange = forceLocationChange || isMobile

        if (navigateByLocationChange) {
            changeBrowserLocation({url: USER_INFO_URL, type: 'PUSH'})

            return Promise.resolve()
        }

        await openPopup({
            key: POPUP_KEY,
            url: USER_INFO_PC_URL,
            title: '회원정보 수정',
            size: {
                width: 500,
                height: 640,
            },
        })

        return Promise.resolve()
    },
)

export default navigateToUserInfo
